/**
 * HeroImageUnavailable.jsx
 * Created by Destin Frasier on 9/14/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './icons/Icons';

const HeroImageUnavailable = ({ hasOverlayCopy = true }) => (
    <div className="rec-hero-image-unavailable-wrap">
        {hasOverlayCopy && (
            <figure>
                <Icons.IconPhotoUnavailable />
                    <figcaption>Photo Unavailable</figcaption>
            </figure>
        )}
    </div>
);

HeroImageUnavailable.propTypes = {
    hasOverlayCopy: PropTypes.bool
};

export default HeroImageUnavailable;
